export enum WEEKDAY {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export const DAY_OF_WEEK_TRANSLATIONS: Record<WEEKDAY, string> = {
  [WEEKDAY.MONDAY]: 'common.days.monday',
  [WEEKDAY.TUESDAY]: 'common.days.tuesday',
  [WEEKDAY.WEDNESDAY]: 'common.days.wednesday',
  [WEEKDAY.THURSDAY]: 'common.days.thursday',
  [WEEKDAY.FRIDAY]: 'common.days.friday',
  [WEEKDAY.SATURDAY]: 'common.days.saturday',
  [WEEKDAY.SUNDAY]: 'common.days.sunday',
};

export const DAY_OF_WEEK_SHORT_TRANSLATIONS: Record<WEEKDAY, string> = {
  [WEEKDAY.MONDAY]: 'common.days.short.monday',
  [WEEKDAY.TUESDAY]: 'common.days.short.tuesday',
  [WEEKDAY.WEDNESDAY]: 'common.days.short.wednesday',
  [WEEKDAY.THURSDAY]: 'common.days.short.thursday',
  [WEEKDAY.FRIDAY]: 'common.days.short.friday',
  [WEEKDAY.SATURDAY]: 'common.days.short.saturday',
  [WEEKDAY.SUNDAY]: 'common.days.short.sunday',
};

export const WORKDAYS = [WEEKDAY.MONDAY, WEEKDAY.TUESDAY, WEEKDAY.WEDNESDAY, WEEKDAY.THURSDAY, WEEKDAY.FRIDAY];
